import { useFetchAssetDetails } from 'src/Hooks/Queries/useFetchAssetDetails';

export const useIsAssetAboveQuotas = () => {
  const { data: asset } = useFetchAssetDetails();

  if (asset) {
    return (
      asset.usage.videos.current > (asset.usage.videos.limit ?? Infinity) ||
      asset.usage.storage.currentMb > asset.usage.storage.limitMb
    );
  } else return false;
};
